import {useContext} from 'react'
import Search from '../../../../components/Search'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import MultipleSelect from '../../../../components/MultiSelect/MultiSelect'
import ExportCSVButton from '../../components/ExportCSVButton'
import {isEmpty} from '../../../../utils/common'
import {BrandReportContext} from '../../context'
import {MIN_DATE_RANGE} from '../../utils'

const BrandReportHeader = () => {
  const {
    onSearch,
    onDateChange,
    onChangeBrandFilter,
    onChangePurchaserFilter,
    onDownloadCSV,
    reportData,
    isLoading,
    brands = [],
    purchasers = [],
    isBrandsLoading = false,
    isPurchasersLoading = false,
  } = useContext(BrandReportContext)
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')

  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChange && onDateChange(startDate, endDate)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex gap-10 align-items-end'>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch && onSearch(searchTerm)
          }}
        />
        <MultipleSelect
          id='brand-filter'
          label='Brand'
          options={brands}
          className='w-200px'
          labelKey='name'
          valueKey='id'
          placeholder='Select Brand(s)'
          allValuesSelectedText='Brand: All'
          isLoading={isBrandsLoading}
          handleSelected={onChangeBrandFilter}
        />
        <MultipleSelect
          id='purchaser-filter'
          label='Purchaser'
          options={purchasers}
          className='w-200px'
          valueKey='purchaser_email'
          labelKey='purchaser_name'
          placeholder='Select Purchaser(s)'
          allValuesSelectedText='Purchaser: All'
          isLoading={isPurchasersLoading}
          handleSelected={onChangePurchaserFilter}
        />
      </div>
      <div className='d-flex gap-5 align-items-end'>
        <ExportCSVButton
          onExportCSV={onDownloadCSV}
          isLoading={isLoading}
          hide={isEmpty(reportData)}
        />

        <div className='w-250px'>
          <PredefinedDateRange
            cb={handleDateChange}
            getLbl={() => {}}
            defaultValue={dateRangeLabel || 'Last 90 Days'}
            includeCurrantDay={true}
            startDate={MIN_DATE_RANGE}
          />
        </div>
      </div>
    </div>
  )
}

export default BrandReportHeader
